module.exports = __webpack_public_path__ + "static/media/ed-tick.ed6bcdbd.svg";